// src/script/index.ts
var loadScriptAsync = async ({
  id,
  target = "body",
  type = "script",
  snippet,
  url
}) => {
  return new Promise((resolve, reject) => {
    const isExist = document.getElementById(id);
    if (isExist) {
      resolve(true);
    } else {
      let el;
      if (type !== "link") {
        el = document.createElement(type);
        el.type = "text/javascript";
        if (url) {
          el.src = url;
        } else {
          el.innerHTML = snippet || "";
        }
      } else {
        el = document.createElement("link");
        el.rel = "stylesheet";
        if (url) {
          el.href = url;
        } else {
          el.innerHTML = snippet || "";
        }
      }
      el.id = id;
      el.onload = resolve;
      el.onerror = reject;
      document[target].prepend(el);
    }
  });
};
var runWhenIdle = (fn, timeout = 2e3) => {
  if (typeof window === "undefined") return;
  const schedule = () => typeof window.requestIdleCallback === "function" ? window.requestIdleCallback(() => fn(), { timeout }) : window.setTimeout(fn, 1);
  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
};

export {
  loadScriptAsync,
  runWhenIdle
};
//# sourceMappingURL=chunk-Q2WHVY5J.mjs.map